import { Component, inject, OnInit, DestroyRef, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ApiConstants } from 'src/app/base/api-constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { UtilService } from 'src/app/services/util.service';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-rename-session',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, ButtonModule, InputTextModule, TranslateModule],
  templateUrl: './rename-session.component.html',
  styleUrls: ['./rename-session.component.scss']
})
export class RenameSessionComponent implements OnInit {
  @Optional() public ref = inject(DynamicDialogRef);
  private readonly config = inject(DynamicDialogConfig);
  private readonly translate = inject(TranslateService);
  private readonly httpBaseService = inject(HttpBaseService);
  private readonly utilService = inject(UtilService);
  private readonly destroyRef = inject(DestroyRef);

  session: any;
  submitted = false;

  Flags: any = {
    isServiceTriggered: false
  };

  renameForm = new FormGroup({
    sessionName: new FormControl<string>('', [Validators.required, Validators.maxLength(100)])
  });

  ngOnInit() {
    this.session = this.config.data?.session;
    if (this.session && this.session.sessionName) {
      this.renameForm.controls.sessionName.setValue(this.session.sessionName);
    }
  }

  save() {
    if (this.renameForm.invalid) {
      return;
    }

    const newName = this.renameForm.value.sessionName?.trim();
    if (!newName) {
      return;
    }

    let payload: any = {
      sessionName: newName,
      pathParams: {
        sessionId: this.session.sid
      }
    };

    this.triggerService(payload);
  }

  close() {
    this.ref.close(false);
  }

  triggerService(payload: any) {
    const apiConstants = ApiConstants.companion.updateSession;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    this.Flags.isServiceTriggered = true;

    return this.httpBaseService[apiConstants.method](apiConstants, payload, { headers })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          this.utilService.showMessage('success', this.translate.instant('SESSION_RENAMED'));
          this.ref.close({ success: true, sessionName: payload.sessionName });
          this.submitted = true;
        },
        error: (serverError: any) => {
          this.Flags.isServiceTriggered = false;
          console.error('Error renaming session', serverError);
        }
      });
  }
}
